// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailsModal_block__D1LsG","fields":"DetailsModal_fields__3j4xK"};